import { render, staticRenderFns } from "./MobileElectronicCard.vue?vue&type=template&id=b8601000&scoped=true&"
import script from "./MobileElectronicCard.vue?vue&type=script&lang=js&"
export * from "./MobileElectronicCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileElectronicCard.vue?vue&type=style&index=0&id=b8601000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8601000",
  null
  
)

export default component.exports